import { Box, Typography, styled } from "@mui/material";
import { NEW_CASE_STEPS } from "../../utils/constants";
import { theme } from "../../theme/theme";
import { tokens } from "../../theme/tokens";

const Stepper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: tokens.space[2],
  flexWrap: "wrap",
  flex: 1,
  minWidth: 0,
});

const Step = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: tokens.space[2],
  minWidth: 0,
});

const Marker = styled(Box)({
  width: tokens.icon.lg,
  height: tokens.icon.lg,
  flex: "0 0 auto",
  borderRadius: tokens.radius.full,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: tokens.type.family,
  fontSize: tokens.type.caption.size,
  fontWeight: tokens.type.denseStrong.weight,
});

const Connector = styled(Box)({
  width: tokens.space[4],
  height: tokens.borderWidth,
  flex: "0 0 auto",
  backgroundColor: tokens.color.border.default,
});

const StepLabel = styled(Typography)({
  fontFamily: tokens.type.family,
  fontSize: tokens.type.dense.size,
  lineHeight: tokens.type.dense.lineHeight,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

interface NewCaseTopBarProps {
  tabIndex: number;
}

const NewCaseTopBar = ({ tabIndex }: NewCaseTopBarProps) => {
  return (
    <Stepper>
      {NEW_CASE_STEPS.map((label, i) => {
        const current = tabIndex === i;
        return (
          <Step key={i}>
            <Marker
              aria-current={current ? "step" : undefined}
              sx={
                current
                  ? {
                      backgroundColor: tokens.color.brand.primaryAction,
                      color: tokens.color.brand.onPrimary,
                    }
                  : {
                      backgroundColor: tokens.color.surface.default,
                      color: tokens.color.text.secondary,
                      border: `${tokens.borderWidth} solid ${tokens.color.border.default}`,
                    }
              }
            >
              {i + 1}
            </Marker>
            <StepLabel
              sx={{
                color: current
                  ? tokens.color.text.primary
                  : tokens.color.text.secondary,
                fontWeight: current
                  ? tokens.type.denseStrong.weight
                  : tokens.type.dense.weight,
              }}
            >
              {label}
            </StepLabel>
            {i < NEW_CASE_STEPS.length - 1 && <Connector />}
          </Step>
        );
      })}
    </Stepper>
  );
};

export default NewCaseTopBar;
